import { InputComp } from '../problems-type-pages/input';
import { ProblemConstructComp } from '../problems-type-pages/problem-construct';
import { DiscourseComp } from '../problems-type-pages/discourse';
import { SelfEvalComp } from '../problems-type-pages/self-eval';
import { PeerEvalComp } from '../problems-type-pages/peer-eval';
import FixedOptionComp from '../problems-type-pages/fixed-option-comp';
import { PageComp } from '../problems-type-pages/page-comp-props';
import { SFFProblemType } from '../common/page-data';

type PageCompMap = {
  [type in SFFProblemType]: PageComp | undefined;
};

const pageCompMap: PageCompMap = {
  [SFFProblemType.Type1]: InputComp,
  [SFFProblemType.Type2]: InputComp,
  [SFFProblemType.Type3]: InputComp,
  [SFFProblemType.Type4]: InputComp,
  [SFFProblemType.Type6]: ProblemConstructComp,
  [SFFProblemType.Type7]: InputComp,
  [SFFProblemType.Discourse]: DiscourseComp,
  [SFFProblemType.DiscourseFixed]: DiscourseComp,
  [SFFProblemType.SelfEval]: SelfEvalComp,
  [SFFProblemType.PeerEval]: PeerEvalComp,
  [SFFProblemType.FixedOption]: FixedOptionComp,

  [SFFProblemType.ModuleIntro]: undefined,
  [SFFProblemType.ModuleCompletion]: undefined,
  [SFFProblemType.SkillCompletion]: undefined,
  [SFFProblemType.TagAnnotation]: undefined,
  [SFFProblemType.AnnotateSingle]: undefined,
  [SFFProblemType.AnnotateMulti]: undefined,
  [SFFProblemType.Type5]: undefined,
};

export function pageCompFactory(type: SFFProblemType): PageComp | undefined {
  const DataType = pageCompMap[type];

  return DataType;
}
